import { render, staticRenderFns } from "./VCardTextWrapper.vue?vue&type=template&id=68ef70f0"
import script from "./VCardTextWrapper.vue?vue&type=script&lang=js"
export * from "./VCardTextWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports